export const get_ref_color = (Impact_Factor_2022)=>{
  let color = '';
  if(['NA', null, ''].indexOf(Impact_Factor_2022) > -1) color = '#A6A6A6';
  else if (Impact_Factor_2022 >= 0 && Impact_Factor_2022 <=5) color = '#5B9BD5';
  else if (Impact_Factor_2022 > 5 && Impact_Factor_2022 <= 10) color = '#70AD47';
  else if (Impact_Factor_2022 > 10 && Impact_Factor_2022 <= 20) color = '#FFC000';
  else if(Impact_Factor_2022 > 20) color = '#FF0000';
  console.log('xxxxx====', Impact_Factor_2022, ['NA', null, ''].indexOf(Impact_Factor_2022) > -1);
  return color
};
